/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


document.addEventListener("DOMContentLoaded", function(event) {

  
    
  const counterEl =  document.querySelector('#section-announcement .AnnouncementBar__Content')
  
  const plurar = (num) => (num>1)?'s':''
   
  const textF = (days,hours,minutes,seconds) => 'Taste Buds 2024 launching in: '+hours.toString().padStart(2, '0')+' hour'+plurar(hours)+': '+minutes.toString().padStart(2, '0')+' minute'+plurar(minutes)+': '+seconds.toString().padStart(2, '0')+' second'+plurar(seconds)+' | <a href="https://ja.nomaprojects.com/pages/early-access">Sign up for early access!</a>'
  
  const eventDate = new Date('2023-12-01T14:00:00.000Z') // it is 18:00 in CET (+1h)
  const startCountingDate = new Date('2023-11-29T14:00:00.000Z') // it is 15:00 in CET (+1h)
  const endCountingDate = new Date('2023-12-01T13:00:00.000Z') // it is 15:00 in CET (+1h)
  
  const dmsec = 24*60*60*1000
  const hmsec = 60*60*1000
  const mmsec = 60*1000
  
  if(startCountingDate < new Date() && new Date() < endCountingDate ) {
    counterEl.addEventListener("click", (e) => {
      window.location = 'https://nomaprojects.com/pages/early-access';
    })
    counterEl.style.cursor = 'pointer';
    setInterval(()=> {
     
     let d = new Date();
  	 let diff = eventDate - d
     
     let days = Math.floor(diff/dmsec)
     let hours = Math.floor((diff)/hmsec)
     let minutes = Math.floor((diff -hours*hmsec)/mmsec)
     let sec = Math.floor((diff -hours*hmsec - minutes*mmsec)/1000)
  	 counterEl.innerHTML  = textF(days,hours,minutes,sec)
  	},1000)
  }

  let products_with_video_hover =  document.querySelectorAll('.product_with_video_hover')  
  for (i = 0; i < products_with_video_hover.length; ++i) {
    let prod = products_with_video_hover[i]
    prod.addEventListener("mouseenter", ( event ) => {
      event.target.querySelector('.product_video_hover video').play()
      
    })
    prod.addEventListener("mouseleave", ( event ) => {
      event.target.querySelector('.product_video_hover video').pause()
      
    })
  }

  if(document.body.classList.contains('homepage')) {
    const sections = document.querySelectorAll('main>.shopify-section')  
    for (i = 0; i < sections.length; ++i) {
      let section = sections[i]
      section.addEventListener("click", ( event ) => {
        let btn = section.querySelector('a.Btn')
        if(btn)btn.click()
      })
    }
  }

  /* CUSTOMER PORTAL */
  if(document.getElementById('recharge-customer-portal')) {
    // add new button to customer portal
    window.onload = () => {
      let d = document.querySelector('a[data-testid="recharge-internal-view-upcoming-deliveries"]')
      const cont = d.parentNode.parentNode;
      if(d) {
        let n = d.parentNode.cloneNode(true);
        if(n.querySelector('span')) {
          n.querySelector('span').innerHTML = 'Taste Buds Discord';
          n.querySelector('a').href="https://discord.com/invite/RhaxSuhPY4?utm_source=brevo&utm_campaign=TB+Discord&utm_medium=email";
          n.querySelector('a').target="_blank"
          n.style.marginTop = '15px';
        }
        cont.prepend(n);
        n = d.parentNode.cloneNode(true);
        if(n.querySelector('span')) {
          n.querySelector('span').innerHTML = 'Member Content';
          n.querySelector('a').href="https://nomaprojects.com/pages/taste-buds-2024-1?ls=BW2OL3g24-hytlDI-dstm";
          n.style.marginTop = '15px';
        }
        cont.prepend(n);
      }
    }
  }

  let teaser_pages_expand =  document.querySelectorAll('.teaser-pages-expand')  
  
  if(teaser_pages_expand) {
    for (i = 0; i < teaser_pages_expand.length; ++i) {
      let page_container = teaser_pages_expand[i]
      if(page_container.dataset.url) {
        fetch(page_container.dataset.url).then((response) => {
        	return response.text();
        }).then((html) => {
        	const show_full_page = page_container.dataset.showFullPage=='true';
        	let parser = new DOMParser();
        	let doc = parser.parseFromString(html, 'text/html');
        	// Get the image file
        	let page_sections = doc.querySelectorAll('main#main>div');
            if(page_sections.length>0) {
              page_container.innerHTML += page_sections[0].innerHTML;
              if(!show_full_page) {
                 page_container.innerHTML +='<a href="#" class="collapse-expand-button expand-button Button Button--secondary Button--full">'+page_container.dataset.buttonLabel+' <svg class="Icon Icon--plus" role="presentation" viewBox="0 0 16 16"><g stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"><path d="M8,1 L8,15"></path><path d="M1,8 L15,8"></path></g></svg></a>';
              }
              let expand_container = document.createElement("div");

              if(!show_full_page) {
                 expand_container.classList.add('expand-section')
              }
              
              for (k = 1; k < page_sections.length; ++k) {
                 expand_container.append(page_sections[k]);
              }
              
              if(!show_full_page) {
                 expand_container.innerHTML+='<a href="#" class="collapse-expand-button collapse-button Button Button--secondary Button--full">'+page_container.dataset.collapseButtonLabel+' <svg class="Icon Icon--minus " role="presentation" viewBox="0 0 16 2"><path d="M1,1 L15,1" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path></svg></a>';
              }
              page_container.append(expand_container)

              var collectionListElements = page_container.querySelectorAll('[data-flickity-config]');
              console.log(collectionListElements)
              collectionListElements.forEach((el) => {
                new window.Carousel(el);
              })
              /*if (collectionListElement) {
                let carousel = 
              }*/

              if(!show_full_page) {
                page_container.querySelector('.expand-button').addEventListener("click",(e)=> {
                    e.preventDefault();
                    let es = e.target.parentNode.querySelector('.expand-section');
                    es.classList.add('show');
                    e.target.classList.add('hide');
                    es.scrollIntoView({behavior: 'smooth'});
                })
                page_container.querySelector('.collapse-button').addEventListener("click",(e)=> {
                    e.preventDefault();
                    let es = e.target.parentNode;
                    page_container.scrollIntoView({behavior: 'smooth'});
                    setTimeout(() => {
                      es.classList.remove('show');
                      page_container.querySelector('.expand-button').classList.remove('hide');
                    }, 500);
                    
                    
                })
              }
               
            }
          
        }).catch((err) => {
        	// There was an error
        	console.warn('Something went wrong.', err);
        });
      }
    }
    
  }

  
   
});